import { Component, OnInit, OnDestroy } from '@angular/core';

import { DialogManagerService } from '@src/services';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { Store } from '@src/store';

import _ from 'lodash';

@Component({
    selector: 'cms-management',
    template: require('./cms-management.component.html'),
    styles: [require('./cms-management.component.scss')]
})
export class CmsManagmentComponent implements OnInit, OnDestroy {
    public cmss: any[];
    public cms: any;

    private ignoreSelectionCms = false;
    private deletePreventAction = false;
    private waitingForResultTest: boolean;
    private tempCms: any;
    private indexInList: any;
    private unSubscribe: any;
    private unSubscribers: any[];

    constructor(private store: Store, private dialogManagerService: DialogManagerService) {
    }

    public ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const cmssState = this.store.getState().cmss;
            if (cmssState && cmssState.cmss && cmssState.cmss.length > 0) {
                if (!this.cmss || (this.cmss.length < cmssState.cmss.length)) {
                    this.cmss = cmssState.cmss;
                    this.cmss = this.cmss.filter(cms => cms.type != 6);
                    this.cms = this.cmss[0];
                }
            }
        });
        this.store.dispatch({ type: cmsActions.GET_ALL_CMS });
    }

    public ngOnDestroy() {
        this.store.dispatch({ type: cmsActions.REFRESH_CMSS });
        this.unSubscribe();
        this.unSubscribers && this.unSubscribers.forEach(x => x());
    }

    public getCms(selectedCMS: any, indexInList: any) {
        this.indexInList = indexInList;
        if (selectedCMS.isNew) {
            this.cms = selectedCMS;
            // for change -1 to new id
            this.unSubscribe = this.store.subscribe(() => {
                if (this.store.getState().cmss.cms) {
                    if (selectedCMS.id == -1 && this.cms) {
                        selectedCMS.id = this.cms.id;
                        this.unSubscribe();
                    }
                }
            });
            return;
        }
        this.unSubscribers = [
            this.store.subscribe(() => {
                const cmssState = this.store.getState().cmss;
                if (cmssState.cms && !this.waitingForResultTest && !this.deletePreventAction) {
                    if (!this.ignoreSelectionCms) {
                        this.cms = cmssState.cmss.find((cms: any) => cms.id == selectedCMS.id);
                        this.tempCms = cmssState.cms;
                        this.updateCmssOnSave();
                    }
                }
            })
        ];
        if (selectedCMS.id != -1) {
            this.store.dispatch({ type: cmsActions.GET_CMS_BY_ID, payload: { cmdId: selectedCMS.id } });
        }
    }

    public addCms() {
        this.cms = { name: 'New Cms', isNew: true, userName: '', password: '', type: null };
        this.tempCms = { name: 'New Cms', isNew: true, userName: '', password: '', type: null };
        if (!this.cmss) {
            this.cmss = [];
        }
        this.cmss = [this.cms, ...this.cmss];
        this.indexInList = 0;
        this.getCms(this.cms, 0);
    }

    public test(data: any) {
        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().cmss && this.store.getState().cmss.test) {
                this.waitingForResultTest = false;
                data.test = this.store.getState().cmss.test;
                this.cms = data;
                this.unSubscribe();
            }
        });

        this.waitingForResultTest = true;
        this.store.dispatch({ type: cmsActions.TEST_CMS_CONNECTION, payload: data });
    }

    public ifTest() {
        return this.cms && this.cms.test;
    }

    public onCancel() {
        this.ignoreSelectionCms = true;
        let selectIdx = this.indexInList;
        const currentCms = this.cmss[selectIdx];
        this.unSubscribe = this.store.subscribe(() => {
            const cmssState = this.store.getState().cmss;
            if (cmssState && cmssState.cmss && cmssState.cmss.length > 0) {
                this.unSubscribe();
                this.cmss = cmssState.cmss;
                this.cmss = this.cmss.filter(cms => cms.type != 6);
                selectIdx = this.cmss.findIndex(cms => cms.id == currentCms.id);
                selectIdx = selectIdx == -1 ? 0 : selectIdx;
                if (!this.tempCms.isNew && selectIdx != 0) {
                    this.cms = this.cmss[selectIdx - 1];
                    this.tempCms = this.cmss[selectIdx - 1];
                }
                if (selectIdx == 0 && this.tempCms.isNew) {
                    this.cmss = [this.tempCms, ...this.cmss];
                    this.indexInList = selectIdx;
                }
                const selectNextItem = () => {
                    this.ignoreSelectionCms = false;
                    // FIX $(`.cmss-container li.spacer:nth-child(${selectIdx + 1})`).click();
                };
                setTimeout(selectNextItem, 0);
            }
        });
        this.store.dispatch({ type: cmsActions.GET_ALL_CMS });
    }

    public delete() {
        this.deletePreventAction = true;
        const onConfirm = async () => {
            if (this.cms.isNew) {
                this.deletePreventAction = false;
                if (this.cmss.length == 1) {
                    this.cmss = [];
                }
                if (this.indexInList >= 0) {
                    if (this.cmss.length > 1) {
                        this.cmss = [...this.cmss.slice(0, this.indexInList), ...this.cmss.slice(this.indexInList + 1)];
                    }
                    this.cms = this.cmss ? this.cmss[0] : null;
                    this.tempCms = this.cmss ? this.cmss[0] : null;
                }
                return;
            }

            this.unSubscribe = this.store.subscribe(() => {
                if (this.store.getState().cmss.cmss) {
                    if (this.cmss.length == 1) {
                        this.cmss = [];
                    } else {
                        const cmss = [];
                        _.each(this.cmss, (item: any) => {
                            if (this.cms.id != item.id) {
                                cmss.push(item);
                            }
                        });
                        this.cmss = cmss;
                    }
                    this.cms = null;
                    this.tempCms = null;
                    this.deletePreventAction = false;
                    this.unSubscribe();
                }
            });

            const response = await this.store.dispatch({
                type: cmsActions.DELETE_CMS,
                payload: { cmsId: this.cms.id }
            });
            if (response.status != 200) {
                this.unSubscribe();
                this.deletePreventAction = false;
            }
        };
        const dialogData = { title: 'Delete CMS', action: 'delete', objectType: 'cms', item: this.cms.name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }

    private updateCmssOnSave() {
        let cmsId = null;
        if (this.tempCms) {
            cmsId = this.tempCms.id;
            this.cms = _.cloneDeep(this.tempCms);
        }
        if (cmsId) {
            const selectedCms = this.cmss.filter(cms => cms.id === cmsId);
            if (selectedCms && selectedCms.length > 0) {
                selectedCms[0].name = this.cms.name;
                selectedCms[0].details = this.cms.details;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/cms-management/cms-management.component.ts